// test-ids

export const CHECKOUT_MAP_CONTAINER_TEST_ID = 'checkout-map-container';
